import axios from 'axios';

import HTTP from '../HTTP';
import config from '../config/config';

const USERS_URL = 'services/commun/Utilisateur/GetByUserName';

export async function getUser(userId) {
  // TODO devrait être basé sur HTTP mais comme la base de l'URL est 'services/gescom/'
  const response = await HTTP.get(config.URL_SERVEUR + USERS_URL, { params: { userId } });
  return response;
}

export async function connexion(payload) {
  const configuration = {};
  if (payload.site) {
    const responseTenant = await axios.post(config.URL_SERVEUR + 'services/app/Account/IsTenantAvailable', { tenancyName: payload.site });
    if (!responseTenant.data.success || responseTenant.data.result.tenantId) {
      configuration.headers = {
        'Abp.TenantId': responseTenant.data.result.tenantId,
      };
    }
  }

  const idConnexion = {
    secondaryUserNameOrEmailAddress: payload.secondaryUserNameOrEmailAddress,
    usernameOrEmailAddress: payload.email,
    password: payload.password,
  };
  const response = await axios.post(config.URL_SERVEUR + 'TokenAuth/Authenticate', idConnexion, configuration);
  return response;
}
